var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#FCF2BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 13.5V18.1667C26.3335 18.4761 26.4564 18.7728 26.6752 18.9916C26.894 19.2104 27.1907 19.3333 27.5002 19.3333H32.1668M26.3335 13.5H18.1668C17.548 13.5 16.9545 13.7458 16.5169 14.1834C16.0793 14.621 15.8335 15.2145 15.8335 15.8333V32.1667C15.8335 32.7855 16.0793 33.379 16.5169 33.8166C16.9545 34.2542 17.548 34.5 18.1668 34.5H29.8335C30.4523 34.5 31.0458 34.2542 31.4834 33.8166C31.921 33.379 32.1668 32.7855 32.1668 32.1667V19.3333M26.3335 13.5L32.1668 19.3333M20.5002 27.5L22.8335 29.8333L27.5002 25.1667",
    stroke: "#E4BE09",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.f6c1eb9627d775a33d7fa3a6c499437c.svg";
export { ForwardRef as ReactComponent };